<template>
  <ViewContainer :px="6">
    <v-tabs-items touchless v-model="activeTab">
      <v-tab-item><SignUpAccount @next="setAccount" /></v-tab-item>
      <v-tab-item><SignUpPhone @next="setPhone" /></v-tab-item>
      <v-tab-item><SignUpAgreement @next="setAgreement" :loading="loading" /></v-tab-item>
    </v-tabs-items>
  </ViewContainer>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  components: {
    SignUpAccount: () => import('@/components/signup/SignUpAccount.vue'),
    SignUpPhone: () => import('@/components/signup/SignUpPhone.vue'),
    SignUpAgreement: () => import('@/components/signup/SignUpAgreement.vue'),
  },
  data() {
    return {
      tabs: {
        account: 0,
        phone: 1,
        agreement: 2,
      },
      activeTab: 0,

      userForm: {
        email: null,
        password1: null,
        password2: null,
        phone: null,
        operationStatus: 'none',
        agreementList: null,
      },

      loading: false,
    }
  },
  watch: {
    activeTab: {
      handler(tab) {
        // 뒤로가기 버튼 액션
        if (tab === 0) {
          this.setBackAction(() => this.$router.go(-1))
        } else {
          this.setBackAction(() => (this.activeTab -= 1))
        }
        // 프로그레스 바 길이
        this.setProgressLength({
          index: this.activeTab,
          length: Object.getOwnPropertyNames({ ...this.tabs }).length,
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters('signup', { registerForm: 'getRegisterForm' }),
  },
  methods: {
    ...mapMutations('ui/header', ['setBackAction', 'setProgressLength']),
    ...mapMutations('signup', ['setRegisterForm']),
    ...mapActions('auth', ['signinSuccess', 'getMe']),
    ...mapActions('signup', ['tempSignup', 'signup']),

    /**
     * 각 단계 완료시 수행
     */
    setAccount(e) {
      this.userForm.email = e.email
      this.userForm.password1 = e.password
      this.userForm.password2 = e.rePassword
      this.activeTab = this.tabs.phone
      this.setRegisterForm(this.userForm)
    },
    setPhone(e) {
      this.userForm.phone = e
      this.activeTab = this.tabs.agreement
      this.setRegisterForm(this.userForm)
    },
    async setAgreement(e) {
      this.userForm.agreementList = e.map((terms) => {
        return { term: terms.uuid, isAgreed: terms.isAgree }
      })
      await this.registerAndSignin()
    },

    /**
     * 회원 가입 처리
     */
    async registerAndSignin() {
      if (this.loading) return

      this.loading = true
      try {
        await this.tempSignup({
          body: {
            email: this.userForm.email,
            password: this.userForm.password,
            phone: this.userForm.phone,
            operationStatus: this.userForm.operationStatus,
          },
        })

        const user = await this.signup({ register: this.userForm })
        if (user) {
          const { accessToken, refreshToken } = user
          this.signinSuccess({ accessToken, refreshToken })

          await this.getMe()

          await this.$router.push({ name: 'signup/mall' })
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep button[type='submit'] .v-btn__content {
  font-size: 16px !important;
  font-weight: bold !important;
}

::v-deep .v-window {
  height: 100%;

  &__container,
  &-item {
    height: 100%;
  }
}
</style>
